import { render } from "./ProjectNotificationFilterForm.vue?vue&type=template&id=67d54738&scoped=true&ts=true"
import script from "./ProjectNotificationFilterForm.vue?vue&type=script&lang=ts"
export * from "./ProjectNotificationFilterForm.vue?vue&type=script&lang=ts"

import "./ProjectNotificationFilterForm.vue?vue&type=style&index=0&id=67d54738&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67d54738"]])

export default __exports__